<template>
  <div class="home">
    <div class="banner">
      <img src="../../assets/image/home/banner.jpg" alt="" class="banner_img" @click="examination" />
    </div>

    <div class="what">
      <h2>什么是<span style="color:#ff462a">生涯规划咨询师</span>？</h2>
      <div class="what_txt">
        <p>
          生涯规划咨询师是个人学习进步和职业生涯发展的重要导师，可以为学生提供全面、专业的生涯规划服务。生涯规划咨询师项目的目标是帮助学生了解自己的兴趣爱好、优点和潜力，进一步明确自己的职业目标，制定科学的职业规划方案，实现自我发展和职业成长的目标。<br />
          通过生涯规划咨询师项目，可以更加深入地了解自己，了解职业市场和职业发展的趋势和方向，提高职业竞争力和自我发展的潜力。同时，生涯规划咨询师项目也可以帮助来访者在高中时期做好学业规划，更好地为未来的职业发展打下坚实的基础。<br />
          生涯规划咨询师能力评测标准和体系的建设是必不可少的。建立科学的生涯规划咨询师能力评测标准和体系，可以帮助评估咨询师的专业水平，提高咨询师的专业素质和服务质量。这样，来访者在选择生涯规划咨询师时可以更加有针对性和选择性。<br />
          这个职业的核心工作内容是：帮助来访者解决学业和职业上的困惑。
        </p>
      </div>
      <div class="text-center ">
        <img src="../../assets/image/home/img1.png" alt="" style="width:230px" />
      </div>
    </div>

    <h2 class="text-center">
      什么是<span style="color:#ff462a">新高考背景下</span>的生涯规划？
    </h2>
    <p class="text-center" style="font-size:14px">
      <br />
      生涯规划包括<span style="color:#ff462a">学业规划</span>和<span style="color:#ff462a">职业规划</span>两个部分。
    </p>

    <div class="container">
      <br />
      <div class="con_bg1">
        <br />
        <h3 class="con_title">
          <img src="../../assets/image/home/icon1.png" class="icon" alt="" />
          学业规划
        </h3>
        <p class="content">
          学业规划是指学生根据自己的兴趣和特长、学业水平、专业性向、生涯发展意向，科学、合理地安排课程修习计划。<br />
          学业规划是生涯规划的主要内容。学业规划的主要目的是指导学生在了解初中和高中课程、学科知识体系、学习要求的差异和自我认知的基础上，更好地适应各个阶段的学习；树立积极的态度，发掘学习潜能，发展学科特长，寻找适合各个阶段和自身特点的学习方法和策略；科学安排各个阶段的修习计划，明确自己的学考、选考意愿；制订参与社团活动、志愿者活动、社会实践、体育锻炼等计划，培养和发展自己的兴趣与特长，处理好学习与生活的关系，科学合理地安排课余时间，养成正确的学习、休息方式。
        </p>
      </div>
      <div class="con_bg2">
        <br />
        <h3 class="con_title">
          <img src="../../assets/image/home/icon2.png" class="icon" alt="" />职业规划
        </h3>
        <p class="content">
          职业规划是指学生对自己未来的生涯发展做出较为全面的设想和计划。学业规划是职业规划的基础，职业规划是学业规划的目标和方向。<br />
          职业规划的主要目的是让学生在了解国内外主要高校的专业信息与社会职业需求、了解专业发展趋向和人才市场需求的前提下，选择合适的发展方向；让学生在选择适合的选修课程和实践活动、了解和体验不同职业的过程中，不断明确学习、成长目标，为专业性发展、职业倾向选择提供判断依据；让学生在了解并掌握升学和就业所需技能的基础上，培养创新精神，树立积极向上的人生态度，努力做对社会有贡献的人。
        </p>
      </div>
    </div>

    <div class="container text-center">
      <h2>为什么要成为<span style="color:#ff462a">生涯规划咨询师</span>？</h2>
      <p>
        <img src="../../assets/image/home/icon.png" alt="" height="30" class="icon" />学生目前存在的问题
      </p>
      <img src="../../assets/image/home/m_img7.png" style="width:70%" alt="" />

      <p>
        <img src="../../assets/image/home/icon.png" alt="" height="30" class="icon" />生涯规划咨询师可以做的
      </p>
      <p class="content list">
      <ul>
        <li>每一个人都有自己独特的潜力和价值，而生涯规划正是帮助个体发现并最大化潜力的过程。</li>
        <li>作为一名生涯规划咨询师，可以与来访者一起探索他们的兴趣、价值观和天赋，帮助他们制定清晰的目标和实现这些目标所需的步骤。</li>
        <li>可以为他们提供职业市场的信息和职业发展趋势，让他们了解行业内的机会和挑战，并帮助他们做出明智的决策。</li>
        <li>每个人都应该有机会追求自己的梦想，而生涯规划咨询师可以帮助来访者了解自己的潜力和兴趣，找到最适合自己的职业方向，并在这个过程中提供必要的支持和指导。</li>
        <li>成为一名生涯规划咨询师能够为年轻人的未来做出积极的贡献。</li>
      </ul>
      </p>
      <img src="../../assets/image/home/img3.png" alt="" width="300">
    </div>

    <div class=" text-center">
      <br>
      <h2>生涯规划咨询师<span style="color:#ff462a">5大</span>学习模块</h2>
      <p style="color:#666666;font-size:12px;">生涯规划咨询师课程的分为5个板块学习</p>
      <div class="module">
        <br>
        <br>
        <img src="../../assets/image/home/m_img8.png" alt="" style="width:65%;">
      </div>
    </div>

    <div class="container">
      <br>
      <h2 class="text-center">生涯规划咨询师<span style="color:#ff462a">适合人群</span></h2>
      <br>
      <div class="box">
        <div class="item" v-for="item in list" :key="item.id">
          <el-row type="flex" justify="space-around" align="middle">
            <el-col :span="12">
              <img :src="item.url" alt="" style="width:80%">
            </el-col>
            <el-col :span="12">
              <h3>{{item.title}}</h3>
              <p>{{item.bottom}}</p>
            </el-col>
          </el-row>
        </div>

      </div>
    </div>

    <div class="footer">
      <div class="text-center">
        <img src="../../assets/image/home/logo_w.png" alt="" width="50%" />
      </div>
      <p>
        <a href="#" @click.prevent="toTeam" style="color: #fff;">师资介绍</a>
      </p>
      <p>客服微信：Netban88</p>
      <p>
        技术支持：021-61806577-8013
      </p>
      <p>
        公司邮箱：office@netban.cn
      </p>
      <p>
        办公地址：上海市静安区万荣路1188号A座龙软大厦6楼
      </p>

      <!-- <p>沪ICP备10203489号-60 版权所有 上海生涯规划咨询师认证</p> -->
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        list: [
          { url: require('../../assets/image/home/img2.png'), title: '高校、中学老师', bottom: '帮助学生进行学业和职业规划，解决学生成长性难题', id: 0 },
          { url: require('../../assets/image/home/img5.png'), title: '想成为生涯规划咨询师的人士', bottom: '掌握整套生涯规划的流程和方法，具备提供咨询服务的能力。', id: 1 },
          { url: require('../../assets/image/home/img4.png'), title: '教培机构从业者', bottom: '系统学习生涯理论知识，帮助业务转型或业务开拓。', id: 2 },
          { url: require('../../assets/image/home/img6.png'), title: '金融、保险行业从业者', bottom: '掌握来访者常见问题的解决方案和思路，运用专业工具达成咨询目标。', id: 3, },
        ],

      }
    },
    created() {
      let _this = this
      if (this.$route.query.id) {
        localStorage.setItem('agent_id', this.$route.query.id)
      }


      this.obj = this.$store.state.wps_user

      // if (_this.$route.params.agent) {
      //   document.cookie = 'agent=' + escape(_this.$route.params.agent.trim())
      // }
    },
    // mounted(){
    //     this.silde()
    // },
    methods: {
      newsInfo(id, type) {
        this.$router.push({
          path: '/newsDesc',
          query: {
            id: id,
            type: type,
          },
        })
      },
      examination() {
        this.$router.push({ path: '/traincourse' })
        // if (this.$store.state.wps_user.mobile) {
        //   this.$router.push({ path: "/mobile/usercenter" });
        // } else {
        //   this.$router.push({ path: "/login" });
        // }
      },
      course() {
        this.showclass = true
      },
      details() {
        this.$router.push({ path: '/webmaster' })
      },
      leftSlide() {
        this.$refs.carousel1.next()
      },
      rightSlide() {
        this.$refs.carousel1.prev()
      },
      left() {
        this.$refs.carousel2.next()
      },
      right() {
        this.$refs.carousel2.prev()
      },
      commentleft() {
        this.$refs.carousel3.next()
      },
      commentright() {
        this.$refs.carousel3.prev()
      },
      toTeam() {
        this.$router.push({ name: 'Mteam' })
      }
    },
    directives: {
      touch: {
        bind: function (el, binding) {
          var touchType = binding.arg //传入的模式 press swipeRight swipeLeft swipeTop swipeDowm Tap
          var timeOutEvent = 0
          var direction = ''
          //滑动处理
          var startX, startY

          //返回角度
          function GetSlideAngle(dx, dy) {
            return (Math.atan2(dy, dx) * 180) / Math.PI
          }

          //根据起点和终点返回方向 1：向上，2：向下，3：向左，4：向右,0：未滑动
          function GetSlideDirection(startX, startY, endX, endY) {
            var dy = startY - endY
            var dx = endX - startX
            var result = 0

            //如果滑动距离太短
            if (Math.abs(dx) < 100 && Math.abs(dy) < 100) {
              return result
            }

            var angle = GetSlideAngle(dx, dy)
            if (angle >= -45 && angle < 45) {
              result = 'swiperight'
            } else if (angle >= 45 && angle < 135) {
              result = 'swipeup'
            } else if (angle >= -135 && angle < -45) {
              result = 'swipedown'
            } else if (
              (angle >= 135 && angle <= 180) ||
              (angle >= -180 && angle < -135)
            ) {
              result = 'swipeleft'
            }
            return result
          }

          el.addEventListener(
            'touchstart',
            function (ev) {
              startX = ev.touches[0].pageX
              startY = ev.touches[0].pageY

              //判断长按
              timeOutEvent = setTimeout(() => {
                timeOutEvent = 0
                if (touchType === 'press') {
                  binding.value()
                }
              }, 500)
            },
            false
          )

          el.addEventListener('touchmove', function () {
            clearTimeout(timeOutEvent)
            timeOutEvent = 0
          })

          el.addEventListener(
            'touchend',
            function (ev) {
              var endX, endY
              endX = ev.changedTouches[0].pageX
              endY = ev.changedTouches[0].pageY
              direction = GetSlideDirection(startX, startY, endX, endY)
              clearTimeout(timeOutEvent)
              switch (direction) {
                case 0:
                  break
                case 'swipeup':
                  if (touchType === 'swipeup') {
                    binding.value()
                  }
                  break
                case 'swipedown':
                  if (touchType === 'swipedown') {
                    binding.value()
                  }
                  break
                case 'swipeleft':
                  if (touchType === 'swipeleft') {
                    binding.value()
                  }
                  break
                case 'swiperight':
                  if (touchType === 'swiperight') {
                    binding.value()
                  }
                  break
                default:
              }
            },
            false
          )
        },
      },
    },
  }
</script>
<style lang="less" scoped>
  .home {
    width: 100%;
  }

  .banner .banner_img {
    width: 100%;
  }

  h2 {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #000005;
  }

  p {
    font-size: 14px;
    color: #333;
    line-height: 20px;
  }

  .what {
    width: 100%;
    padding: 20px 0px;

    .what_txt {
      width: 80vw;
      margin: 20px auto;
    }
  }

  .container {
    margin: 0 10px;

    .con_title {
      text-align: left;
      padding-left: 20px;
      padding-top: 10px;
    }

    .content {
      padding: 8px 26px;
    }

    .icon {
      vertical-align: middle;
    }
  }

  .con_bg1 {
    min-height: 520px;
    background: url('../../assets/image/home/m_bg_4.png') no-repeat;
    background-size: 100% 520px;
    margin-bottom: 30px;
  }

  .con_bg2 {
    min-height: 520px;
    background: url('../../assets/image/home/m_bg5.png') no-repeat;
    background-size: 100% 520px;
  }

  .list {
    text-align: left;
    color: #7C8087;
    margin-left: 15px;
  }

  .module {
    padding-bottom: 20px;
    background: url('../../assets/image/home/m_bg3.png') no-repeat;
    background-size: 100%;


  }

  .footer {
    padding: 20px 0px;
    background-color: #2b2b2b;
    width: 100%;

    p {
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      margin-top: 8px;
    }
  }

  .item {
    flex: 1;
    border: 1px solid #FD7150;
    border-radius: 8px;
    margin: 0 20px 20px 20px;
    padding: 10px;

    p {
      font-size: 12px;
      margin-top: 5px;
    }
  }
</style>